import React from "react";
import { NumberBox, SelectBox, Button } from "devextreme-react";

const Pagination = ({
  gotoPage,
  previousPage,
  canNextPage,
  canPreviousPage,
  pageOptions,
  pageCount,
  pageIndex,
  setPageSize,
  nextPage,
  pageSize,
  isReport,
}) => {
  return (
    <div className="pagination" style={isReport ? { marginTop: "40px" } : {}}>
      <div className="d-flex align-items-center">
        <span className="mr-3">
          Page{" "}
          <strong>
            {pageIndex + 1} of {pageOptions.length}
          </strong>{" "}
        </span>
        <span className="mr-3">|</span>
        <span className="mr-3">Go to page:</span>
        {/* <input
            type="number"
            defaultValue={pageIndex + 1}
            onChange={(e) => {
              const page = e.target.value ? Number(e.target.value) - 1 : 0;
              gotoPage(page);
            }}
            style={{ width: "100px" }}
          /> */}
        <div className="mr-3">
          <NumberBox
            mode="number"
            showSpinButtons={true}
            value={pageIndex + 1}
            onValueChanged={(e) => {
              const page = e.value ? Number(e.value) - 1 : 0;
              gotoPage(page);
            }}
          />
        </div>
        <div>
          <SelectBox
            dataSource={[20, 30, 50, 100].map((pageSize) => ({
              display: `Show ${pageSize}`,
              value: pageSize,
            }))}
            displayExpr="display"
            showDropDownButton={true}
            showClearButton={false}
            valueChangeEvent="keyup"
            valueExpr="value"
            value={pageSize}
            onValueChanged={(e) => {
              setPageSize(Number(e.value));
            }}
          />
        </div>
        {/* <select
          value={pageSize}
          className="form-select"
          onChange={(e) => {
            setPageSize(Number(e.target.value));
          }}
        >
          {[10, 20, 30, 40, 50].map((pageSize) => (
            <option key={pageSize} value={pageSize}>
              Show {pageSize}
            </option>
          ))}
        </select> */}
      </div>
      <div>
        <Button
          onClick={() => gotoPage(0)}
          disabled={!canPreviousPage}
          icon="chevrondoubleleft"
          stylingMode="contained"
          type="default"
          className="mr-2"
        />
        <Button
          onClick={() => previousPage()}
          disabled={!canPreviousPage}
          icon="chevronprev"
          stylingMode="contained"
          type="default"
          className="mr-2"
        />
        <Button
          onClick={() => nextPage()}
          disabled={!canNextPage}
          icon="chevronnext"
          stylingMode="contained"
          type="default"
          className="mr-2"
        />
        <Button
          onClick={() => gotoPage(pageCount - 1)}
          disabled={!canNextPage}
          icon="chevrondoubleright"
          stylingMode="contained"
          type="default"
        />
      </div>
    </div>
  );
};

export default Pagination;
